import React, { useState, useEffect, useCallback } from "react";
import "../styles/filtersection.css";
import {
  FaPlus,
  FaMinus,
  FaTimes,
  FaFilter,
  FaChevronRight,
  FaChevronDown,
} from "react-icons/fa";
import ReactSlider from "react-slider";
import { useDispatch, useSelector } from "react-redux";
import { fetchFilteredProducts } from "../actions/FilterActions";
import { fetchCategories } from "../actions/categoriesActions";
import { useLocation } from "react-router-dom";
import store from "../store";

const FilterSection = ({
  category_id,
  isSearchPage = false,
  filters,
  setFilters,
  categories: propCategories,
}) => {
  const [expandedSections, setExpandedSections] = useState(["Categories"]);
  const [expandedCategories, setExpandedCategories] = useState(new Set());
  const [selectedFilters, setSelectedFilters] = useState({});
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q") || "";

  // Get all categories from Redux store for filtering
  const { categories: reduxCategories } = useSelector(
    (state) => state.categories,
  );

  // Fetch categories if not already loaded
  useEffect(() => {
    if (!reduxCategories || reduxCategories.length === 0) {
      dispatch(fetchCategories());
    }
  }, [dispatch, reduxCategories]);

  // Use prop categories if provided, otherwise use Redux categories
  // Filter to only show top-level categories (those without a parent)
  const categories =
    propCategories && propCategories.length > 0
      ? propCategories
      : reduxCategories?.filter(
          (cat) => !cat.parent_id || cat.parent_id === null,
        ) || [];
  const [tags, setTags] = useState([
    "HOT DEAL",
    "NEW ARRIVAL",
    "BEST SELLER",
    "LIMITED TIME",
    "FREE SHIPPING",
  ]);
  const [features, setFeatures] = useState([
    "Moisturising",
    "Low irritant",
    "Absorbs quickly",
    "Anti-aging",
    "Brightening",
  ]);
  const [skin_concern, setskin_concern] = useState([
    "Acne",
    "Blackheads",
    "Brightening",
    "Deep cleansing",
    "Fine dust removal",
    "Moisturizing",
    "Soothing",
    "Visible pores",
    "Well-aging",
  ]);
  const [skin_type, setskin_type] = useState([
    "Dry",
    "Oily",
    "Sensitive",
    "Combination&Normal",
  ]);
  const [formulations, setFormulations] = useState([
    "Ampolues",
    "Cream",
    "Fluid",
    "Gel",
    "Toners",
  ]);

  // const { categories } = useSelector(state => state.categories);

  const toggleSection = (section) => {
    setExpandedSections((prev) =>
      prev.includes(section)
        ? prev.filter((s) => s !== section)
        : [...prev, section],
    );
  };

  const toggleCategoryExpand = (categoryId) => {
    setExpandedCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
  };

  const isCategoryExpanded = (categoryId) => {
    return expandedCategories.has(categoryId);
  };

  // Function to find category name by ID recursively
  const findCategoryNameById = (catList, targetId) => {
    if (!catList || !Array.isArray(catList)) return null;
    for (const cat of catList) {
      if (cat.category_id === targetId) return cat.name;
      if (
        cat.children &&
        Array.isArray(cat.children) &&
        cat.children.length > 0
      ) {
        const found = findCategoryNameById(cat.children, targetId);
        if (found) return found;
      }
    }
    return null;
  };

  // Get selected category names for badges (only show top-level selected categories)
  const getSelectedCategoryBadges = () => {
    if (!filters.category_id || filters.category_id.length === 0) return [];

    // Helper function to check if a category ID is a child of any selected parent
    const isChildOfSelectedParent = (categoryId) => {
      const findCategory = (catList, targetId) => {
        if (!catList || !Array.isArray(catList)) return null;
        for (const cat of catList) {
          if (cat.category_id === targetId) return cat;
          if (
            cat.children &&
            Array.isArray(cat.children) &&
            cat.children.length > 0
          ) {
            const found = findCategory(cat.children, targetId);
            if (found) return found;
          }
        }
        return null;
      };

      // Check if this category is a child of any selected category
      for (const selectedId of filters.category_id) {
        const selectedCategory = findCategory(categories, selectedId);
        if (selectedCategory && selectedId !== categoryId) {
          const allDescendants = collectAllCategoryIds(selectedCategory);
          if (allDescendants.includes(categoryId)) {
            return true; // This is a descendant of another selected category
          }
        }
      }
      return false;
    };

    // Only show badges for categories that are directly selected (not just included as descendants)
    const topLevelSelected = filters.category_id.filter(
      (categoryId) => !isChildOfSelectedParent(categoryId),
    );

    return topLevelSelected
      .map((categoryId) => {
        const name = findCategoryNameById(categories, categoryId);
        return name ? { id: categoryId, name } : null;
      })
      .filter(Boolean); // Remove null values
  };

  const handleRemoveCategoryBadge = (categoryId) => {
    // Find the category to get all its nested IDs
    const findCategory = (catList, targetId) => {
      if (!catList || !Array.isArray(catList)) return null;
      for (const cat of catList) {
        if (cat.category_id === categoryId) return cat;
        if (
          cat.children &&
          Array.isArray(cat.children) &&
          cat.children.length > 0
        ) {
          const found = findCategory(cat.children, targetId);
          if (found) return found;
        }
      }
      return null;
    };

    const category = findCategory(categories, categoryId);

    if (category) {
      // Remove all nested category IDs
      const allCategoryIds = collectAllCategoryIds(category);
      setFilters({
        ...filters,
        category_id: filters.category_id.filter(
          (id) => !allCategoryIds.includes(id),
        ),
      });
    } else {
      // If category not found, just remove the single ID
      setFilters({
        ...filters,
        category_id: filters.category_id.filter((id) => id !== categoryId),
      });
    }
  };

  // const getAllChildren = async (category) => {
  //   // loop through categories and return all children and sub children
  //   if (!category.children) {
  //     return [];
  //   }
  //   const children = [...category.children];
  //   children.forEach(child => {
  //     if (child.children) {
  //       child.children.forEach(subChild => {
  //         children.push(subChild);
  //       });
  //     }
  //   });
  //   console.log('children', children);
  //   return children;
  // }

  const handleFilterChange = (category, option) => {};
  const handlePriceRangeChange = (value) => {};
  const clearAllFilters = () => {};
  const removeFilter = (category, option) => {};
  // Recursive function to collect all nested category IDs
  const collectAllCategoryIds = (category) => {
    const ids = [category.category_id];
    if (
      category.children &&
      Array.isArray(category.children) &&
      category.children.length > 0
    ) {
      category.children.forEach((child) => {
        ids.push(...collectAllCategoryIds(child));
      });
    }
    return ids;
  };

  const handleCheckCategory = (categoryId) => {
    // Find the category in the categories tree
    const findCategory = (catList, targetId) => {
      if (!catList || !Array.isArray(catList)) return null;
      for (const cat of catList) {
        if (cat.category_id === categoryId) return cat;
        if (
          cat.children &&
          Array.isArray(cat.children) &&
          cat.children.length > 0
        ) {
          const found = findCategory(cat.children, targetId);
          if (found) return found;
        }
      }
      return null;
    };

    const category = findCategory(categories, categoryId);

    if (!category) {
      // If category not found, just toggle the single ID
      if (filters.category_id.includes(categoryId)) {
        setFilters({
          ...filters,
          category_id: filters.category_id.filter((id) => id !== categoryId),
        });
      } else {
        setFilters({
          ...filters,
          category_id: [...filters.category_id, categoryId],
        });
      }
      return;
    }

    // Collect all nested category IDs for this category
    const allCategoryIds = collectAllCategoryIds(category);

    // Check if any of these IDs are already in filters
    const hasAnySelected = allCategoryIds.some((id) =>
      filters.category_id.includes(id),
    );

    if (hasAnySelected) {
      // Remove all nested category IDs
      setFilters({
        ...filters,
        category_id: filters.category_id.filter(
          (id) => !allCategoryIds.includes(id),
        ),
      });
    } else {
      // Add all nested category IDs
      const newCategoryIds = [
        ...new Set([...filters.category_id, ...allCategoryIds]),
      ];
      setFilters({
        ...filters,
        category_id: newCategoryIds,
      });
    }
  };
  const handleCheckTag = (tag) => {
    if (filters.tags.includes(tag)) {
      setFilters({
        ...filters,
        tags: filters.tags.filter((t) => t !== tag),
      });
    } else {
      setFilters({
        ...filters,
        tags: [...filters.tags, tag],
      });
    }
    setShowFilters(false);
  };
  const handleCheckFeature = (feature) => {
    if (filters.features.includes(feature)) {
      setFilters({
        ...filters,
        features: filters.features.filter((f) => f !== feature),
      });
    } else {
      setFilters({
        ...filters,
        features: [...filters.features, feature],
      });
    }
    setShowFilters(false);
  };
  const handleCheckConcern = (concern) => {
    if (filters.skin_concern.includes(concern)) {
      setFilters({
        ...filters,
        skin_concern: filters.skin_concern.filter((c) => c !== concern),
      });
    } else {
      setFilters({
        ...filters,
        skin_concern: [...filters.skin_concern, concern],
      });
    }
    setShowFilters(false);
  };
  const handleCheckSkinType = (type) => {
    if (filters.skin_type.includes(type)) {
      setFilters({
        ...filters,
        skin_type: filters.skin_type.filter((t) => t !== type),
      });
    } else {
      setFilters({
        ...filters,
        skin_type: [...filters.skin_type, type],
      });
    }
    setShowFilters(false);
  };
  const handleCheckFormulation = (formulation) => {
    if (filters.fomulation.includes(formulation)) {
      setFilters({
        ...filters,
        fomulation: filters.fomulation.filter((f) => f !== formulation),
      });
    } else {
      setFilters({
        ...filters,
        fomulation: [...filters.fomulation, formulation],
      });
    }
    setShowFilters(false);
  };

  const commaSeparateNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const [showFilters, setShowFilters] = useState(false);
  const isMobile = () => {
    return window.innerWidth < 768;
  };

  return (
    <>
      <div
        className={`filter-section ${
          isMobile() && !showFilters ? "mobile" : ""
        }`}
      >
        {isMobile() && (
          <div className="close-filters" onClick={() => setShowFilters(false)}>
            Close Filters
          </div>
        )}
        <div className="filter-header">
          <div className="filter-title">
            <h3>REFINE</h3>
            <p className="clear-all" onClick={clearAllFilters}>
              Clear all
            </p>
          </div>
        </div>

        {/* Selected Filters Display */}
        {(Object.keys(selectedFilters).length > 0 ||
          filters.min_price !== 0 ||
          filters.max_price !== 10000000) && (
          <div className="selected-filters">
            {Object.entries(selectedFilters).map(([category, options]) =>
              options.map((option) => (
                <span key={`${category}-${option}`} className="selected-filter">
                  {option}
                  <FaTimes
                    className="remove-filter"
                    onClick={() => removeFilter(category, option)}
                  />
                </span>
              )),
            )}
            {(filters.min_price !== 0 || filters.max_price !== 10000000) && (
              <span className="selected-filter">
                {filters.min_price} - {filters.max_price}
                <FaTimes
                  className="remove-filter"
                  onClick={() => handlePriceRangeChange([0, 10000000])}
                />
              </span>
            )}

            {filters.tags.map((tag) => (
              <span key={tag} className="selected-tag selected-filter">
                {tag}
                <FaTimes
                  className="remove-filter"
                  onClick={() => handleCheckTag(tag)}
                />
              </span>
            ))}
          </div>
        )}

        {/* Price Range Section */}
        <div className="filter-category price-section">
          <div className="category-header">
            <h4>Price</h4>
          </div>
          <div className="category-options">
            <ReactSlider
              className="horizontal-slider"
              thumbClassName="thumb"
              trackClassName="track"
              min={0}
              max={100000}
              value={[filters.min_price, filters.max_price]}
              onChange={handlePriceRangeChange}
            />
            <div className="price-range-values">
              <span>{filters.min_price} RWF</span> -{" "}
              <span>{commaSeparateNumber(filters.max_price)} RWF</span>
            </div>
          </div>
        </div>

        {/* brand input */}
        <div className="filter-category brand-input">
          <div className="category-header">
            <h4>Brand</h4>
          </div>
          <div className="category-options">
            <input
              type="text"
              placeholder="Search brand"
              value={filters.brand}
              onChange={(e) =>
                setFilters({ ...filters, brand: e.target.value })
              }
            />
          </div>
        </div>

        {/* Categories Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Categories</h4>
            {expandedSections.includes("Categories") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Categories")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Categories")}
              />
            )}
          </div>
          {/* Selected Category Badges */}
          {expandedSections.includes("Categories") &&
            filters.category_id &&
            filters.category_id.length > 0 && (
              <div className="selected-category-badges">
                {getSelectedCategoryBadges().map((badge) => (
                  <span
                    key={badge.id}
                    className="category-badge"
                    onClick={() => handleRemoveCategoryBadge(badge.id)}
                  >
                    {badge.name}
                    {badge.productCount > 0 && (
                      <span className="badge-product-count">
                        ({badge.productCount})
                      </span>
                    )}
                    <FaTimes className="badge-remove-icon" />
                  </span>
                ))}
              </div>
            )}
          {expandedSections.includes("Categories") && (
            <div className="category-options">
              {categories && categories.length > 0 ? (
                categories.map((category) => {
                  // Recursive function to render nested categories
                  const renderCategoryTree = (cat, level = 0) => {
                    const hasChildren =
                      cat.children &&
                      Array.isArray(cat.children) &&
                      cat.children.length > 0;
                    const indentStyle = { paddingLeft: `${level * 20}px` };
                    const productCount = cat.product_count || 0;
                    const isExpanded = isCategoryExpanded(cat.category_id);

                    return (
                      <div key={cat.category_id} style={indentStyle}>
                        <div className="category-option flex items-center gap-2">
                          {hasChildren ? (
                            <button
                              type="button"
                              className="category-expand-toggle"
                              onClick={() =>
                                toggleCategoryExpand(cat.category_id)
                              }
                              aria-label={isExpanded ? "Collapse" : "Expand"}
                            >
                              {isExpanded ? (
                                <FaChevronDown className="expand-icon" />
                              ) : (
                                <FaChevronRight className="expand-icon" />
                              )}
                            </button>
                          ) : (
                            <span className="category-expand-spacer" />
                          )}
                          <input
                            type="checkbox"
                            id={`cat-${cat.category_id}`}
                            name={cat.name}
                            onChange={() =>
                              handleCheckCategory(cat.category_id)
                            }
                            checked={filters.category_id.includes(
                              cat.category_id,
                            )}
                          />
                          <label htmlFor={`cat-${cat.category_id}`}>
                            {cat.name}
                            {productCount > 0 && (
                              <span className="product-count-badge">
                                ({productCount})
                              </span>
                            )}
                          </label>
                        </div>
                        {hasChildren && isExpanded && (
                          <div className="nested-categories">
                            {cat.children.map((child) =>
                              renderCategoryTree(child, level + 1),
                            )}
                          </div>
                        )}
                      </div>
                    );
                  };

                  return renderCategoryTree(category, 0);
                })
              ) : (
                <p className="no-categories-message">No categories available</p>
              )}
            </div>
          )}
        </div>

        {/* Tags Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Tags</h4>
            {expandedSections.includes("Tags") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Tags")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Tags")}
              />
            )}
          </div>
          {expandedSections.includes("Tags") && (
            <div className="category-options">
              {tags.map((tag) => (
                <div
                  key={tag}
                  className="category-option flex items-center gap-2"
                >
                  <input
                    type="checkbox"
                    id={tag}
                    name={tag}
                    onChange={() => handleCheckTag(tag)}
                    checked={filters.tags.includes(tag)}
                  />
                  <label htmlFor={tag}>{tag}</label>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Features Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Features</h4>
            {expandedSections.includes("Features") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Features")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Features")}
              />
            )}
          </div>
          {expandedSections.includes("Features") && (
            <div className="category-options">
              {features.map((feature) => (
                <div
                  key={feature}
                  className="category-option flex items-center gap-2"
                >
                  <input
                    type="checkbox"
                    id={feature}
                    name={feature}
                    onChange={() => handleCheckFeature(feature)}
                    checked={filters.features.includes(feature)}
                  />
                  <label htmlFor={feature}>{feature}</label>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Skin Concerns Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Skin Concerns</h4>
            {expandedSections.includes("Skin Concerns") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Skin Concerns")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Skin Concerns")}
              />
            )}
          </div>
          {expandedSections.includes("Skin Concerns") && (
            <div className="category-options">
              {skin_concern.map((concern) => (
                <div
                  key={concern}
                  className="category-option flex items-center gap-2"
                >
                  <input
                    type="checkbox"
                    id={concern}
                    name={concern}
                    onChange={() => handleCheckConcern(concern)}
                    checked={filters.skin_concern.includes(concern)}
                  />
                  <label htmlFor={concern}>{concern}</label>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Skin Types Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Skin Types</h4>
            {expandedSections.includes("Skin Types") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Skin Types")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Skin Types")}
              />
            )}
          </div>
          {expandedSections.includes("Skin Types") && (
            <div className="category-options">
              {skin_type.map((type) => (
                <div
                  key={type}
                  className="category-option flex items-center gap-2"
                >
                  <input
                    type="checkbox"
                    id={type}
                    name={type}
                    onChange={() => handleCheckSkinType(type)}
                    checked={filters.skin_type.includes(type)}
                  />
                  <label htmlFor={type}>{type}</label>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Formulations Section */}
        <div className="filter-category">
          <div className="category-header">
            <h4>Formulations</h4>
            {expandedSections.includes("Formulations") ? (
              <FaMinus
                className="toggle-icon"
                onClick={() => toggleSection("Formulations")}
              />
            ) : (
              <FaPlus
                className="toggle-icon"
                onClick={() => toggleSection("Formulations")}
              />
            )}
          </div>
          {expandedSections.includes("Formulations") && (
            <div className="category-options">
              {formulations.map((formulation) => (
                <div
                  key={formulation}
                  className="category-option flex items-center gap-2"
                >
                  <input
                    type="checkbox"
                    id={formulation}
                    name={formulation}
                    onChange={() => handleCheckFormulation(formulation)}
                    checked={filters.fomulation.includes(formulation)}
                  />
                  <label htmlFor={formulation}>{formulation}</label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className={`filter-toggler ${!isMobile() ? "none" : ""}`}>
        <button onClick={() => setShowFilters(!showFilters)}>
          {showFilters ? <FaTimes /> : <FaFilter />} Filter
        </button>
      </div>
    </>
  );
};

export default FilterSection;
